import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5d60f7e8 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _e5ff0c86 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _35cf3874 = () => interopDefault(import('../../../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _028edf35 = () => interopDefault(import('../../../pages/confirmation.vue' /* webpackChunkName: "pages/confirmation" */))
const _31f5a350 = () => interopDefault(import('../../../pages/customer-terms.vue' /* webpackChunkName: "pages/customer-terms" */))
const _a39545ba = () => interopDefault(import('../../../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _ca87d4ac = () => interopDefault(import('../../../pages/join.vue' /* webpackChunkName: "pages/join" */))
const _765ff799 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _0b98d930 = () => interopDefault(import('../../../pages/modern-slavery.vue' /* webpackChunkName: "pages/modern-slavery" */))
const _37de0038 = () => interopDefault(import('../../../pages/organisation-sign-up.vue' /* webpackChunkName: "pages/organisation-sign-up" */))
const _14a3388e = () => interopDefault(import('../../../pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _6e3ee26c = () => interopDefault(import('../../../pages/premium/index.vue' /* webpackChunkName: "pages/premium/index" */))
const _d4af49d2 = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _4f654ed8 = () => interopDefault(import('../../../pages/review.vue' /* webpackChunkName: "pages/review" */))
const _d3ddd5b0 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _6f25d44a = () => interopDefault(import('../../../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _23523ad4 = () => interopDefault(import('../../../pages/store/index.vue' /* webpackChunkName: "pages/store/index" */))
const _033d4533 = () => interopDefault(import('../../../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _4d5d0ff6 = () => interopDefault(import('../../../pages/website-terms.vue' /* webpackChunkName: "pages/website-terms" */))
const _b06f99e0 = () => interopDefault(import('../../../pages/account/details.vue' /* webpackChunkName: "pages/account/details" */))
const _5028dd07 = () => interopDefault(import('../../../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _47cdfca5 = () => interopDefault(import('../../../pages/account/premium.vue' /* webpackChunkName: "pages/account/premium" */))
const _97be9f5e = () => interopDefault(import('../../../pages/premium/individual.vue' /* webpackChunkName: "pages/premium/individual" */))
const _d029b4ec = () => interopDefault(import('../../../pages/verify/new.vue' /* webpackChunkName: "pages/verify/new" */))
const _a68f56fc = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _66c40061 = () => interopDefault(import('../../../pages/payment/_id.vue' /* webpackChunkName: "pages/payment/_id" */))
const _75a5e139 = () => interopDefault(import('../../../pages/premium/_tier.vue' /* webpackChunkName: "pages/premium/_tier" */))
const _23142984 = () => interopDefault(import('../../../pages/reset-password/_id.vue' /* webpackChunkName: "pages/reset-password/_id" */))
const _219b998c = () => interopDefault(import('../../../pages/store/_slug.vue' /* webpackChunkName: "pages/store/_slug" */))
const _f7955eb8 = () => interopDefault(import('../../../pages/verify/_id.vue' /* webpackChunkName: "pages/verify/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _5d60f7e8,
    name: "404"
  }, {
    path: "/about",
    component: _e5ff0c86,
    name: "about"
  }, {
    path: "/checkout",
    component: _35cf3874,
    name: "checkout"
  }, {
    path: "/confirmation",
    component: _028edf35,
    name: "confirmation"
  }, {
    path: "/customer-terms",
    component: _31f5a350,
    name: "customer-terms"
  }, {
    path: "/forgot",
    component: _a39545ba,
    name: "forgot"
  }, {
    path: "/join",
    component: _ca87d4ac,
    name: "join"
  }, {
    path: "/login",
    component: _765ff799,
    name: "login"
  }, {
    path: "/modern-slavery",
    component: _0b98d930,
    name: "modern-slavery"
  }, {
    path: "/organisation-sign-up",
    component: _37de0038,
    name: "organisation-sign-up"
  }, {
    path: "/payment",
    component: _14a3388e,
    name: "payment"
  }, {
    path: "/premium",
    component: _6e3ee26c,
    name: "premium"
  }, {
    path: "/privacy-policy",
    component: _d4af49d2,
    name: "privacy-policy"
  }, {
    path: "/review",
    component: _4f654ed8,
    name: "review"
  }, {
    path: "/search",
    component: _d3ddd5b0,
    name: "search"
  }, {
    path: "/sign-up",
    component: _6f25d44a,
    name: "sign-up"
  }, {
    path: "/store",
    component: _23523ad4,
    name: "store"
  }, {
    path: "/success",
    component: _033d4533,
    name: "success"
  }, {
    path: "/website-terms",
    component: _4d5d0ff6,
    name: "website-terms"
  }, {
    path: "/account/details",
    component: _b06f99e0,
    name: "account-details"
  }, {
    path: "/account/orders",
    component: _5028dd07,
    name: "account-orders"
  }, {
    path: "/account/premium",
    component: _47cdfca5,
    name: "account-premium"
  }, {
    path: "/premium/individual",
    component: _97be9f5e,
    name: "premium-individual"
  }, {
    path: "/verify/new",
    component: _d029b4ec,
    name: "verify-new"
  }, {
    path: "/",
    component: _a68f56fc,
    name: "index"
  }, {
    path: "/payment/:id",
    component: _66c40061,
    name: "payment-id"
  }, {
    path: "/premium/:tier",
    component: _75a5e139,
    name: "premium-tier"
  }, {
    path: "/reset-password/:id?",
    component: _23142984,
    name: "reset-password-id"
  }, {
    path: "/store/:slug",
    component: _219b998c,
    name: "store-slug"
  }, {
    path: "/verify/:id?",
    component: _f7955eb8,
    name: "verify-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
